import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';

@Component({
  selector: 'z-confirmation-modal',
  standalone: false,
  templateUrl: './confirmation-modal.component.html'
})
export class ConfirmationModalComponent implements OnInit, OnDestroy {

  @Input()
  title: string;

  @Input()
  body: string;

  @Input()
  documentBodyClass: string;

  @Output()
  close = new EventEmitter<boolean>();

  constructor(private renderer: Renderer2) { }

  ngOnInit() {
    this.renderer.addClass(document.body, this.documentBodyClass);
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, this.documentBodyClass);
  }

}
